module.exports = __webpack_public_path__ + "img/iconLastPage.6023b772.svg";